import React, { useState, useEffect } from "react";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import eyeimg from "../../images/eye.svg";

import {
  getReportedPost,
  handleDisablePost,
} from "../services/providerService";
import Dropdown from "react-bootstrap/Dropdown";
import { BsThreeDotsVertical } from "react-icons/bs";

import { Modal, Button } from "react-bootstrap";
import "./ReportPostList.css";
export default function ReportPostList() {
  const [reportedPatientData, setReportedPatientData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [show, setShow] = useState(false);
  const [reportPostData, setReportPostData] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    __getReportedPost(limit, page);
  }, [page , limit]);

  const __getReportedPost = async (limit = 10, page = 0) => {
    try {
      const response = await getReportedPost({ limit, page: page + 1 });
      if (response?.status === "SUCCESS") {
        setReportedPatientData(response?.data?.items);
        setTotalItems(response.data?.totalItems);
        setTotalPages(response.data?.totalPages);
      } else {
      }
    } catch (err) {
      console.error("Error fetching topics:", err);
    }
  };

  // Toggle the modal
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      {/* table for tratment lis  */}
      <div className="table-responsive dashboard-table report-post-list">
        <table className="patients-table">
          <thead>
            <tr className="t-row-block">
              <th scope="col">Sr No</th>
              <th scope="col"> Post Author </th>
              <th scope="col">Reported By</th>
              <th scope="col">Reasons</th>
              <th scope="col">Reported On</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {reportedPatientData?.length > 0 ? (
              reportedPatientData?.map((post, index) => (
                <tr key={post.id || index}>
                  <td scope="row" style={{ borderLeft: "0px" }}>
                    {index + 1 + page * limit}
                  </td>
                  <td>{post.post?.author?.name}</td>

                  <td>{post?.reported_by?.name}</td>

                  <td>{post?.reason}</td>

                  <td style={{ borderRight: "0px" }}>
                    {new Date(post?.createdAt).toLocaleString("en-US", {
                      hour12: true,
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </td>
                  <td>
                    <div className="d-flex gap-3">
                      <a
                        className="edit-del-icon eye-edit-del eye-img"
                        onClick={() => {
                          handleShow();
                          setReportPostData(post);
                        }}
                      >
                        <img src={eyeimg} alt="view" />
                      </a>

                      <a className="edit-del-icon eye-edit-del eye-img ">
                        <Dropdown className="ms-1">
                          <Dropdown.Toggle
                            as="div"
                            id="dropdown-custom-components"
                            className="three-dots"
                          >
                            <BsThreeDotsVertical size={24} />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={async () => {
                                await handleDisablePost({
                                  _id: post._id,
                                  status: "resolved",
                                  isDesabled: true,
                                });
                                await __getReportedPost();
                              }}
                            >
                              Mark Post Disabled
                            </Dropdown.Item>

                            <Dropdown.Item
                              onClick={async () => {
                                await handleDisablePost({
                                  _id: post._id,
                                  status: "resolved",
                                  isDesabled: false,
                                });
                                await __getReportedPost();
                              }}
                            >
                              Mark Post Correct
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </a>
                   
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  Reported post not found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="container">
        {/* Modal */}
        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          aria-labelledby="report-modal-title"
          centered
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="report-modal-title">
              Report and Post Details
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="card shadow-sm border-0">
              <div className="card-header  fw-semibold">Report Details</div>
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-6 d-flex text-md-left gap-2">
                    <strong>Reported By: </strong> 
                    {/* <br /> */}
                    {reportPostData?.reported_by?.name} (
                    {reportPostData?.reported_by?.email})
                  </div>
                  <div className="col-md-6 d-flex text-md-left gap-2">
                    <strong>Status: </strong> 
                    {/* <br /> */}
                    <span className="badge bg-warning text-dark">
                      {reportPostData?.status.toUpperCase()}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6  d-flex text-md-left gap-2">
                    <strong>Reason: </strong> 
                    {/* <br /> */}
                    <span className="text-danger">
                      {" "}
                      {reportPostData?.reason}{" "}
                    </span>
                  </div>
                  <div className="col-md-6 d-flex text-md-left gap-2">
                    <strong>Created At:</strong> 
                    {/* <br /> */}
                    {new Date(reportPostData?.createdAt).toLocaleString()}
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6 d-flex text-md-left gap-2">
                    <strong>Post Content: </strong> 
                    {/* <br /> */}
                    {reportPostData?.post?.content}
                  </div>
                  <div className="col-md-6 d-flex text-md-left gap-2">
                    <strong>Author: </strong> 
                    {/* <br /> */}
                    {reportPostData?.post.author.name}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                   
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="btn btn-primary outlined-btn" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <div className="pagination-blk">
        <CustomPagination
          totalItems={totalItems}
          page={page}
          onPageChange={handleChangePage}
          limit={limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </>
  );
}
